<script lang="ts" setup>
import type { GlobalPrimitiveFieldId, GlobalSingleRelationFieldId, ResolvedMonospaceCollection } from '#layers/data-model/public';
import { CollectionFieldSelect } from '#layers/data-model/public';

defineProps<{
	collection: ResolvedMonospaceCollection;
}>();

const modelValue = defineModel<GlobalPrimitiveFieldId | GlobalSingleRelationFieldId | null>({ required: true });
</script>

<template>
	<CollectionFieldSelect
		v-model="modelValue"
		:collection
		include-primitive-fields
		include-relation-fields
	/>
</template>
